<template>
  <div>
    <ProductInfo :product="product" />

    <VTableLocal
      disablePagination
      isSearchable
      isSelectable
      :items="sites"
      :headers="tableHeaders"
      :title="$t('associatedProducts.associatedSites')"
      @select-row="onClickSite"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import ProductInfo from '@/views/associatedProducts/ProductInfo';

export default {
    components: {
        ProductInfo,
        VTableLocal,
    },
    computed: {
        ...mapGetters([
            'client',
            'lang',
            'product',
        ]),
        tableHeaders() {
            return [
                'name',
                'deliveryAccountNumber',
            ].map(header => ({
                text: this.$t(`sitesByClients.labels.${header}`),
                value: header,
            }));
        },
        sites() {
            const { associatedSites } = this.product;
            return Array.isArray(associatedSites) ? associatedSites : [];
        },
    },
    watch: {
        lang() {
            this.reloadClientProduct({
                clientId: this.client.id,
                productId: this.product.id,
            });
        },
    },
    methods: {
        ...mapActions({
            reloadClientProduct: 'getClientProductInfo',
        }),
        onClickSite(site) {
            this.$router.push({
                name: 'sitePage',
                params: {
                    siteId: site.id,
                },
            });
        },
    },
};
</script>
